if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');
      }

      get variantIdInput() {
        return this.querySelector('.sticky-atc-bar__variant-id');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');
        this.container = this.closest('.sticky-atc-bar');
        this.variantData = this.getVariantData();
        // Set initial currentVariant from main form's selected variant
        const mainFormIdInput = document.querySelector('.main-product-form input[name="id"]');
        if (mainFormIdInput) {
          const initialId = parseInt(mainFormIdInput.value, 10);
          this.currentVariant = this.variantData.find(v => v.id === initialId)
            || this.variantData[0];
        }
        this.init();
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }
        this.productId = this.dataset.productId;

        const mql = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        const rootMargin = `${this.productFormActions.offsetHeight}px 0px 0px 0px`;

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.container.classList.toggle('sticky-atc-bar--show', !entry.isIntersecting);
            });
          },
          { threshold: 0, rootMargin }
        );
        this.observer.observe(this.productFormActions);

        // Immediate check — if ATC buttons are already below the viewport on load
        // (small screen, lots of content above), show sticky bar right away
        this.checkIfAlreadyOffscreen();
        this.syncWithMainProductForm();
      }

      checkIfAlreadyOffscreen() {
        const rect = this.productFormActions.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        // If the bottom of the ATC block is below the viewport bottom on load, show sticky immediately
        if (rect.bottom > viewportHeight || rect.top < 0) {
          this.container.classList.add('sticky-atc-bar--show');
        }
      }

      checkDevice() {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        // Button submits the main product form via form= attribute
        const addButton = this.querySelector('.product-form__submit[name="add"]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('.btn__text');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text && addButtonText) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          if (addButtonText) addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }
      }

      updatePrice() {
        if (!this.currentVariant) return;

        const { price, compare_at_price, available } = this.currentVariant;
        const moneyFormat = FoxTheme.settings.moneyFormat;
        const fmt = (amt) => FoxTheme.Currency.formatMoney(amt, moneyFormat);

        const priceWrapper   = this.querySelector('.f-price');
        const saleEl         = this.querySelector('.f-price-item--sale');
        const regularEls     = this.querySelectorAll('.f-price-item--regular');

        if (!priceWrapper) return;

        const onSale = compare_at_price && compare_at_price > price;

        // Toggle sale/regular classes
        priceWrapper.classList.toggle('f-price--on-sale', onSale);
        priceWrapper.classList.toggle('f-price--sold-out', !available);

        if (onSale) {
          // Sale price in the sale element
          if (saleEl) saleEl.innerHTML = fmt(price);
          // Strike-through compare price in regular element(s)
          regularEls.forEach(el => {
            el.innerHTML = `<s>${fmt(compare_at_price)}</s>`;
          });
        } else {
          // No sale — show price in regular element
          if (saleEl) saleEl.innerHTML = fmt(price);
          regularEls.forEach(el => {
            el.innerHTML = fmt(price);
          });
        }
      }

      syncWithMainProductForm() {
        // Build list of this product's variant ids to scope the event correctly
        // (same reliable pattern used in pdp-specs-tab and pdp-cta-block)
        const variantIds = this.variantData.map(v => String(v.id));

        // Also subscribe to the native input[name="id"] change event as a fallback
        document.addEventListener('change', (e) => {
          if (e.target.name !== 'id') return;
          if (variantIds.indexOf(String(e.target.value)) === -1) return;
          const variant = this.variantData.find(v => v.id === parseInt(e.target.value, 10));
          if (!variant) return;
          this.currentVariant = variant;
          this.updatePrice();
          this.updateButton(true, '', false);
          this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
        });

        // Also keep pubsub for instant update
        FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event.data.variant;
          if (!variant) return;
          if (variantIds.indexOf(String(variant.id)) === -1) return;
          this.currentVariant = variant;
          this.updatePrice();
          this.updateButton(true, '', false);
          this.updateButton(!variant.available, FoxTheme.variantStrings.soldOut);
        });
      }
    }
  );
}
